var $c5df0169c370d169$exports = {};
$c5df0169c370d169$exports = {
    "(optional)": `(optional)`,
    "(required)": `(erforderlich)`
};


export {$c5df0169c370d169$exports as default};
//# sourceMappingURL=de-DE.module.js.map
